import React from "react";
import { RiArrowDownSLine, RiArrowUpSLine } from "react-icons/ri";
import Typography from "../Typography";

const ExpandableSection = ({ title, expanded = false, onToggle, className = "", children }) => {
  return (
    <div className={`w-full ${className}`}>
      {/* Header / Toggle Button */}
      <button
        type="button"
        onClick={onToggle}
        className="
          flex items-center gap-2
          text-text-primary
          hover:text-theme-primary
          transition-colors
          select-none
          mb-4
        "
      >
        {/* Arrow Icon */}
        <span className="flex items-center justify-center">
          {expanded ? <RiArrowUpSLine size={20} /> : <RiArrowDownSLine size={20} />}
        </span>

        {/* Title */}
        <Typography variant="text1" component="span" className="font-semibold text-theme-primary">
          {title}
        </Typography>
      </button>

      {/* Expand Content */}
      <div
        className={`
          overflow-hidden transition-all duration-300
          ${expanded ? "max-h-[500px] opacity-100 mt-3" : "max-h-0 opacity-0"}
        `}
      >
        {children}
      </div>
    </div>
  );
};

export default ExpandableSection;
